import * as CL from '@design-system/component-library';
import { useState } from 'react';
import { ELISA_ID_MIGRATION_DEADLINE } from '../../common/constants/commonConstants.js';
import { dsClass } from '../../common/constants/dsClasses.js';
import {
  activateNewElisaIdMsg,
  elisaIdMigrationAccountsDiscontinuedOnMsg,
  elisaIdMigrationActivateBeforeDateMsg,
  elisaIdMigrationBenefitsBannerMsg,
  elisaIdMigrationNoPersonalIdMsg,
  elisaIdMigrationStartActivationMsg,
  formatDate,
  hereMsg,
  proceedToAuthenticationMsg,
  t,
} from '../../common/i18n/index.js';
import { IdentityProvider } from '../../generated/api/identityProvider.js';
import { useAuth } from '../../public/site/AuthProvider.js';

import './ElisaIdMigrationCard.scss';

export const ElisaIdMigrationCard = () => {
  const { authenticatedUser, prepareElisaIdLogin, inMigrationPhase } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  if (!inMigrationPhase || authenticatedUser?.identityProvider !== IdentityProvider.SSO) {
    return null;
  }

  const formattedDeadline = formatDate(ELISA_ID_MIGRATION_DEADLINE);

  return (
    <div className={`of-elisa-id-migration-banner ${dsClass.DISPLAY_FLEX}`}>
      <div className="of-elisa-id-migration-banner__icon" />
      <h3>{t.F2S0(activateNewElisaIdMsg)}</h3>
      <p>
        {t.LGO8(elisaIdMigrationBenefitsBannerMsg)}{' '}
        {formattedDeadline && (
          <>
            {t.PRM5(elisaIdMigrationAccountsDiscontinuedOnMsg)} <strong>{formattedDeadline}</strong>
            {t.SG1R(elisaIdMigrationActivateBeforeDateMsg)}
          </>
        )}
      </p>
      <p>
        <strong>{t.TX9O(elisaIdMigrationStartActivationMsg)}</strong> {t.UOFI(elisaIdMigrationNoPersonalIdMsg)}
        <CL.Button color="link-button" onClick={() => prepareElisaIdLogin()}>
          {t.OP1Q(hereMsg)}
        </CL.Button>
        .
      </p>
      <div className="of-elisa-id-migration-banner__action">
        <CL.Button
          color="primary"
          size="l"
          loading={isLoading}
          disabled={isLoading}
          onClick={() => {
            setIsLoading(true);
            prepareElisaIdLogin({ migrate: true, register: true });
          }}
        >
          {t.ZUFX(proceedToAuthenticationMsg)}
        </CL.Button>
      </div>
    </div>
  );
};
